import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild, NgModule} from '@angular/core';
import { FormControl, FormGroup, FormsModule, NgModel, ReactiveFormsModule, Validators } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faUser, faLock, faEnvelope, faAddressBook, faPhone, faXmark, faList, faEye, faEyeSlash} from '@fortawesome/free-solid-svg-icons';
import { RegisterFormType, RegisterResponseBody, Organisation } from '../../models/types';
import { LoginService } from '../services/login.service';
import { HttpClientModule } from '@angular/common/http';
import { JwtToken, LoginResponseBody } from '../../models/types';
import  Swal from 'sweetalert2';
import { Router } from '@angular/router';

// Add the following import statement if it is missing

@Component({
  selector: 'app-register-page',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    FontAwesomeModule,
    ReactiveFormsModule,
  ],
  templateUrl: './register-page.component.html',
  styleUrl: './register-page.component.scss'
})
export class RegisterPageComponent {

  @ViewChild("contentContainer") contentContainer!: any;
  @Input() registerAdmin: boolean = false

  @Output() onCloseClicked: EventEmitter<any> = new EventEmitter<any>();

  isFormWarningDisplayed = false;
  isRegistering = false;
  showRegistration = false;

  loginUsername = "";
  loginPassword = "";

  faUser = faUser;
  faLock = faLock;
  faEnvelope = faEnvelope;
  faAddressBook = faAddressBook;
  faPhone = faPhone;
  faXmark = faXmark;
  faList = faList
  faEye = faEye;
  faEyeSlash = faEyeSlash;

  registrationFormGroup!: FormGroup<RegisterFormType>
  isLoggingIn = false;
  show = false; // For toggling password visibility

  organisations: Organisation[] = []; // Store the available organizations
  selectedOrganisations: number[] = []; // Store selected organization IDs

  constructor(
    private loginService: LoginService,
    private router: Router
  ) {}

  get username() {
    return this.registrationFormGroup.get("username");
  }
  get password() {
    return this.registrationFormGroup.get("password");
  }
  get name() {
    return this.registrationFormGroup.get("name");
  }
  get surname() {
    return this.registrationFormGroup.get("surname");
  }
  get department() {
    return this.registrationFormGroup.get("department");
  }
  get role() {
    return this.registrationFormGroup.get("role");
  }
  get address() {
    return this.registrationFormGroup.get("address");
  }
  get phone() {
    return this.registrationFormGroup.get("phone");
  }
  get email() {
    return this.registrationFormGroup.get("email");
  }

  ngOnInit(): void {
      this.registrationFormGroup = new FormGroup({
        username: new FormControl("", [Validators.required]),
        password: new FormControl("", [Validators.required]),
        name: new FormControl("", []),
        surname: new FormControl("", []),
        department: new FormControl("", []),
        role: new FormControl("", []),
        address: new FormControl("", []),
        phone: new FormControl("", []),
        email: new FormControl("", [Validators.required])
      })
      this.registrationFormGroup.valueChanges.subscribe(changes => {
        console.log('Username is invalid:', this.registrationFormGroup.controls.username);
      });

      this.loadOrganisations();
  }

  loadOrganisations() {
    this.loginService.getAllOrganisations().subscribe({
      next: (response) => {
        // Check the response structure
        console.log('Raw response:', response);
  
        // Extract the organisations array from the response body
        if (response.body && Array.isArray(response.body.organisations)) {
          this.organisations = response.body.organisations.filter((org: Organisation) => org.organisationID !== -1);
        } else {
          console.error('Unexpected response structure:', response.body);
        }
        console.log('Organisations fetched:', this.organisations);
      },
      error: (err) => {
        console.error('Error fetching organisations:', err);
      }
    });
  }
  
  
  OnRegisterCloseClicked() {
    this.onCloseClicked.emit();
  }

  toggleForm(): void {
    this.showRegistration = !this.showRegistration;
  }

  OnEnterPressed(): void {
    if (!this.isLoggingIn) {
      this.OnLoginPressed();
    }
  }

  OnRegisterSubmitted() {
    if (this.registrationFormGroup.valid) {
        this.isRegistering = true;

        let registerData = {
            email: this.email!.value!,
            username: this.username!.value!,
            password: this.password!.value!,
            name: "",
            surname: "",
            department: "",
            role: "",
            ...(this.address!.value! != "" && { address: this.address!.value! }),
            ...(this.phone!.valid && { phone: this.phone!.value! }),
            organisations: this.selectedOrganisations // Add selected organisations
        };
        if (this.registerAdmin) {
            registerData.name = this.name!.value!;
            registerData.surname = this.surname!.value!;
            registerData.department = this.department!.value!;
            registerData.role = this.role!.value!;
        }

        this.loginService.SendRegisterInfo(registerData).subscribe({
            next: (value) => {
                this.isRegistering = false;
                Swal.fire({
                    title: 'Uspešna registracija',
                    text: 'Registracija uspešna: Verifikacijsko sporočilo je bilo poslano na vaš elektronski naslov.',
                    icon: 'success',
                    confirmButtonText: 'OK'
                }).then(() => {
                  this.router.navigate(['redirect']);
                });
                console.log(value); // Keep for debugging purposes, if necessary
            },
            error: (err) => {
                this.isRegistering = false;
                const response = err as RegisterResponseBody;
                Swal.fire({
                    title: 'Napaka ',
                    text: 'Pri registraciji je prišlo do napake, prosim poskusite spet kasneje.',
                    icon: 'error',
                    confirmButtonText: 'OK'
                });
                switch (err.status) {
                    case 409:
                        Swal.fire({
                            title: 'Napaka',
                            text: 'Napaka pri registraciji: Uporabniško ime ali elektronski naslov že obstajata.',
                            icon: 'warning',
                            confirmButtonText: 'OK'
                        });
                        break;
                    default:
                        Swal.fire({
                            title: 'Napaka',
                            text: 'Neznana napaka pri registraciji. Poskusite ponovno kasneje.',
                            icon: 'warning',
                            confirmButtonText: 'OK'
                        });
                        break;
                }
            }
        });
    }
}

OnLoginPressed() {
  this.isLoggingIn = true;
  this.loginService.SendLoginInfo(
    {
      username: this.loginUsername,
      password: this.loginPassword,
      is_admin: false,
    }
  ).subscribe({
    next: (data) => {
      const response: LoginResponseBody = data.body as LoginResponseBody;
      this.loginService.SetToken(response.token);
      this.loginService.onUserLoggedIn.emit();
      Swal.fire({
        title: "Prijava uspešna",
        text: `Dobrodošli, ${this.loginUsername}!`,
        icon: "success",
        showConfirmButton: true,
        confirmButtonText: "Zapri"
      }).then(() => {
        window.location.reload();
      });
    },
    error: (err) => {
      this.isLoggingIn = false;
      let errorMessage = "Napaka pri prijavi.";
      if (err.status === 401) {
        errorMessage = "Uporabniško ime ali geslo nista pravilna.";
      }
      Swal.fire({
        title: "Napaka pri prijavi",
        text: errorMessage,
        icon: "error",
        showConfirmButton: true,
        confirmButtonText: "Zapri"
      });
    }
  });
}

onOrganisationSelected(organisationID: number, event: any) {
  if (event.target.checked) {
    this.selectedOrganisations.push(organisationID);
  } else {
    const index = this.selectedOrganisations.indexOf(organisationID);
    if (index > -1) {
      this.selectedOrganisations.splice(index, 1);
    }
  }
}

togglePassword() {
  this.show = !this.show;
}

}
